module.exports = __webpack_public_path__ + "img/windsock3.3610fb65.gif";